var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisabledRemoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_25467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6443 8.26409C16.6443 8.14623 16.5478 8.04981 16.43 8.04981L14.6621 8.05784L11.9996 11.2319L9.3398 8.06052L7.56927 8.05248C7.45141 8.05248 7.35498 8.14623 7.35498 8.26677C7.35498 8.31766 7.37373 8.36588 7.40587 8.40606L10.8907 12.5578L7.40587 16.7069C7.37351 16.7462 7.35555 16.7954 7.35498 16.8462C7.35498 16.9641 7.45141 17.0605 7.56927 17.0605L9.3398 17.0525L11.9996 13.8784L14.6594 17.0498L16.4273 17.0578C16.5452 17.0578 16.6416 16.9641 16.6416 16.8436C16.6416 16.7927 16.6228 16.7444 16.5907 16.7043L13.1112 12.5552L16.5961 8.40338C16.6282 8.36588 16.6443 8.31498 16.6443 8.26409Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5C5.37321 0.5 0 5.87321 0 12.5C0 19.1268 5.37321 24.5 12 24.5C18.6268 24.5 24 19.1268 24 12.5C24 5.87321 18.6268 0.5 12 0.5ZM12 22.4643C6.49821 22.4643 2.03571 18.0018 2.03571 12.5C2.03571 6.99821 6.49821 2.53571 12 2.53571C17.5018 2.53571 21.9643 6.99821 21.9643 12.5C21.9643 18.0018 17.5018 22.4643 12 22.4643Z",
    fill: "#969696"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_25467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledRemoveIcon);
export default __webpack_public_path__ + "static/media/disabled-remove-icon.b9ac08a341af5dd011727edf26343164.svg";
export { ForwardRef as ReactComponent };